<template>
    <div class="product-list">
        <h2 class="text-xl font-bold mb-4">Productos destacados</h2>
        <div v-if="loading" class="text-center">Cargando productos...</div>
        <div v-if="!loading && products.length === 0" class="text-center">No hay productos disponibles.</div>
        <div v-if="!loading && products.length > 0" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div v-for="product in products" :key="product.id" class="product-item">
                <div class="block rounded overflow-hidden shadow hover:shadow-lg transition">
                    <img v-if="product.featuredImage" :src="product.featuredImage" :alt="product.title"
                        class="w-full h-48 object-cover" />
                    <div class="p-4">
                        <h3 class="text-lg font-semibold mb-2">{{ product.title }}</h3>
                        <p class="text-sm text-gray-600">{{ product.price }}</p>
                        <a :href="getCheckoutUrl(product.id)" target="_blank"
                            class="mt-4 inline-block bg-blue-600 text-white text-sm font-semibold px-4 py-2 rounded hover:bg-blue-700 transition">
                            COMPRAR AHORA
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "ProductList",
    data() {
        return {
            products: [],
            loading: true,
        };
    },
    methods: {
        // Genera la URL directa al checkout con el producto en el carrito
        getCheckoutUrl(productId) {
            // La cantidad (1) y el ID del producto se configuran en la URL de Shopify
            return `https://tienda.orsai.org/cart/${productId}:1`;
        },
    },
    async mounted() {
        try {
            // GraphQL query para obtener los productos
            const query = `
        {
          products(first: 6) {
            edges {
              node {
                id
                title
                featuredImage {
                  url
                }
                onlineStoreUrl
                variants(first: 1) {
                  edges {
                    node {
                      id
                    }
                  }
                }
                priceRange {
                  minVariantPrice {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
        }
      `;

            // Petición a la Shopify Storefront API
            const response = await axios.post(
                "https://tienda.orsai.org/api/2023-01/graphql.json",
                { query },
                {
                    headers: {
                        "X-Shopify-Storefront-Access-Token": "0601f486448cb11b7bb5991ac5b7e907", // Reemplaza con tu token de acceso
                        "Content-Type": "application/json",
                    },
                }
            );

            // Procesar los datos de la respuesta
            this.products = response.data.data.products.edges.map(({ node }) => ({
                id: node.variants.edges[0].node.id.split("/").pop(), // Obtén solo el último segmento del ID (variant_id)
                title: node.title,
                featuredImage: node.featuredImage?.url || null,
                onlineStoreUrl: node.onlineStoreUrl,
                price: `${node.priceRange.minVariantPrice.amount} ${node.priceRange.minVariantPrice.currencyCode}`,
            }));
        } catch (error) {
            console.error("Error fetching products:", error);
        } finally {
            this.loading = false;
        }
    },
};
</script>

<style scoped>
.product-list {
    /* max-width: 1200px; */
    margin: 0 auto;
}

.product-item img {
    transition: transform 0.3s;
}

.product-item:hover img {
    transform: scale(1.05);
}
</style>
